// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__sidebar_menu {
  padding-left: 0px;
  margin-top: 30px !important;
}
.__sidebar_menu .__sidebar_menu_item {
  color: #6A6A9F !important;
}
.__sidebar_menu .__sidebar_menu_active {
  color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/components/SidebarMenu/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,2BAAA;AACF;AACE;EACE,yBAAA;AACJ;AAOE;EACE,cAAA;AALJ","sourcesContent":[".__sidebar_menu {\n  padding-left: 0px;\n  margin-top: 30px !important;\n\n  .__sidebar_menu_item {\n    color: #6A6A9F !important;\n  }\n\n  &:hover {\n    .__sidebar_menu_item {\n    }\n  }\n\n  .__sidebar_menu_active {\n    color: #000000;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
